import { useState } from "react";

export default function Input({
    label = false, id, icon = false, onChange, parentValue, errors = false, placeholder = false, type = "text"
}) {
    const [phone, setPhone] = useState('');
    const onChangeLocal = (e, id) => {
        if (type == 'tel') {
            const formatted = formatPhoneNumber(e.target.value);
            e.target.value = formatted;
            setPhone(formatted);
        }
        onChange(e.target.value, id)
    }
    // const formatPhoneNumber = (value) => {
    //     const cleaned = value.replace(/\D/g, '');
    //     let formatted = cleaned;
    
    //     if (cleaned.length >= 6) {
    //       formatted = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    //     } else if (cleaned.length >= 3) {
    //       formatted = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    //     }
    
    //     return formatted;
    //   };
    const formatPhoneNumber = (value) => {
        const previousValue = phone
        const isDeleting = previousValue && value.length < previousValue.length;
      
        if (isDeleting) {
          const lastChar = previousValue[value.length];
          if (lastChar === ')' || lastChar === '-' || lastChar === ' ') {
            value = value.slice(0, -1);
          }
        }
      
        const cleaned = value.replace(/\D/g, '');
        let formatted = cleaned;
      
        if (cleaned.length >= 6) {
          formatted = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
        } else if (cleaned.length > 3) {  // ← changed >= 3 to > 3
          formatted = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
        } else if (cleaned.length === 3 && !isDeleting) {  // ← only add "(" ")" if not deleting
          formatted = `(${cleaned})`;
        } else {
          formatted = cleaned; // ← just return raw digits while deleting through the "(" area
        }
      
        return formatted;
      };
    return (
        <div>
            {label ? 
            <label className="block text-sm font-medium text-gray-700 mb-2 text-left">
                {label}
            </label>
            : ''}
            <div className="relative">
                {icon ? 
                <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                    {icon}
                </div>
                : ''
                }
                
                <input
                    onChange={(e) => onChangeLocal(e, id)}
                    type={type}
                    required
                    id={id}
                    placeholder={placeholder ? placeholder : ''}
                    className={`w-full pl-10 pr-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent ${errors ? "border-red-500" : "border-gray-300"}`}
                    defaultValue={parentValue}
                />
            </div>
            {errors && (
            <p className="mt-1 text-sm text-red-600">{errors.message}</p>
            )}
        </div>
    )
}